export default __webpack_public_path__ + "static/media/wa.604226c7.jpg";